import BatchClaimerABI from './abis/BatchClaimer.js';
import DappMaintenanceABI from './abis/DappMaintenance.js';
import ERC20ABI from './abis/ERC20.js';
import ExchangeRatesABI from './abis/ExchangeRates.js';
import ExchangerABI from './abis/Exchanger.js';
import FuturesMarketDataABI from './abis/FuturesMarketData.js';
import FuturesMarketSettingsABI from './abis/FuturesMarketSettings.js';
import KwentaArrakisVaultABI from './abis/KwentaArrakisVault.js';
import KwentaStakingRewardsABI from './abis/KwentaStakingRewards.js';
import KwentaStakingRewardsV2ABI from './abis/KwentaStakingRewardsV2.js';
import MarginEngineABI from './abis/MarginEngine.js';
import MulticallABI from './abis/Multicall3_1.js';
import MultipleMerkleDistributorOpABI from './abis/MultipleMerkleDistributorOp.js';
import MultipleMerkleDistributorPerpsV2ABI from './abis/MultipleMerkleDistributorPerpsV2.js';
import Permit2ABI from './abis/Permit2.js';
import PerpsV2MarketDataABI from './abis/PerpsV2MarketData';
import PerpsV2MarketSettingsABI from './abis/PerpsV2MarketSettings';
import PerpsV3MarketProxyABI from './abis/PerpsV3MarketProxy';
import SpotV3MarketProxy from './abis/SpotV3MarketProxy';
import PythABI from './abis/Pyth.js';
import RewardEscrowABI from './abis/RewardEscrow.js';
import RewardEscrowV2ABI from './abis/RewardEscrowV2.js';
import SmartMarginAccountFactoryAbi from './abis/SmartMarginAccountFactory.js';
import StakingRewardsABI from './abis/StakingRewards.js';
import SupplyScheduleABI from './abis/SupplySchedule.js';
import SynthetixABI from './abis/Synthetix.js';
import SynthRedeemerABI from './abis/SynthRedeemer.js';
import SynthSwapABI from './abis/SynthSwap.js';
import SynthUtilABI from './abis/SynthUtil.js';
import SystemSettingsABI from './abis/SystemSettings.js';
import SystemStatusABI from './abis/SystemStatus.js';
import vKwentaRedeemerABI from './abis/vKwentaRedeemer.js';
import veKwentaRedeemerABI from './abis/veKwentaRedeemer.js';
import PerpsV3AccountProxyABI from './abis/PerpsV3AccountProxy.js';
import EscrowMigratorABI from './abis/EscrowMigrator.js';
import BoostNftABI from './abis/BoostNFT.js';
import SynthetixV3ProxyABI from './abis/SynthetixV3Proxy.js';
import GnosisSafeL2ProxyABI from './abis/GnosisSafeL2Proxy.js';
import { ADDRESSES } from './constants.js';
export const getContractsByNetwork = (networkId) => {
    return {
        Exchanger: ADDRESSES.Exchanger[networkId]
            ? {
                address: ADDRESSES.Exchanger[networkId],
                abi: ExchangerABI,
            }
            : undefined,
        ExchangeRates: ADDRESSES.ExchangeRates[networkId]
            ? {
                address: ADDRESSES.ExchangeRates[networkId],
                abi: ExchangeRatesABI,
            }
            : undefined,
        SystemStatus: ADDRESSES.SystemStatus[networkId]
            ? {
                address: ADDRESSES.SystemStatus[networkId],
                abi: SystemStatusABI,
            }
            : undefined,
        SynthUtil: ADDRESSES.SynthUtil[networkId]
            ? {
                address: ADDRESSES.SynthUtil[networkId],
                abi: SynthUtilABI,
            }
            : undefined,
        SystemSettings: ADDRESSES.SystemSettings[networkId]
            ? {
                address: ADDRESSES.SystemSettings[networkId],
                abi: SystemSettingsABI,
            }
            : undefined,
        SynthRedeemer: ADDRESSES.SynthRedeemer[networkId]
            ? {
                address: ADDRESSES.SynthRedeemer[networkId],
                abi: SynthRedeemerABI,
            }
            : undefined,
        FuturesMarketData: ADDRESSES.FuturesMarketData[networkId]
            ? {
                address: ADDRESSES.FuturesMarketData[networkId],
                abi: FuturesMarketDataABI,
            }
            : undefined,
        FuturesMarketSettings: ADDRESSES.FuturesMarketSettings[networkId]
            ? {
                address: ADDRESSES.FuturesMarketSettings[networkId],
                abi: FuturesMarketSettingsABI,
            }
            : undefined,
        PerpsV2MarketData: ADDRESSES.PerpsV2MarketData[networkId]
            ? {
                address: ADDRESSES.PerpsV2MarketData[networkId],
                abi: PerpsV2MarketDataABI,
            }
            : undefined,
        PerpsV2MarketSettings: ADDRESSES.PerpsV2MarketSettings[networkId]
            ? {
                address: ADDRESSES.PerpsV2MarketSettings[networkId],
                abi: PerpsV2MarketSettingsABI,
            }
            : undefined,
        Pyth: ADDRESSES.Pyth[networkId]
            ? {
                address: ADDRESSES.Pyth[networkId],
                abi: PythABI,
            }
            : undefined,
        Synthetix: ADDRESSES.Synthetix[networkId]
            ? {
                address: ADDRESSES.Synthetix[networkId],
                abi: SynthetixABI,
            }
            : undefined,
        SynthSwap: ADDRESSES.SynthSwap[networkId]
            ? {
                address: ADDRESSES.SynthSwap[networkId],
                abi: SynthSwapABI,
            }
            : undefined,
        SUSD: ADDRESSES.SUSD[networkId]
            ? {
                address: ADDRESSES.SUSD[networkId],
                abi: ERC20ABI,
            }
            : undefined,
        USDC: ADDRESSES.USDC[networkId]
            ? {
                address: ADDRESSES.USDC[networkId],
                abi: ERC20ABI,
            }
            : undefined,
        USDT: ADDRESSES.USDT[networkId]
            ? {
                address: ADDRESSES.USDT[networkId],
                abi: ERC20ABI,
            }
            : undefined,
        DAI: ADDRESSES.DAI[networkId]
            ? {
                address: ADDRESSES.DAI[networkId],
                abi: ERC20ABI,
            }
            : undefined,
        LUSD: ADDRESSES.LUSD[networkId]
            ? {
                address: ADDRESSES.LUSD[networkId],
                abi: ERC20ABI,
            }
            : undefined,
        SUSD_V3: ADDRESSES.SUSD_V3[networkId]
            ? {
                address: ADDRESSES.SUSD_V3[networkId],
                abi: ERC20ABI,
            }
            : undefined,
        SUSDC_V3: ADDRESSES.SUSDC_V3[networkId]
            ? {
                address: ADDRESSES.SUSDC_V3[networkId],
                abi: ERC20ABI,
            }
            : undefined,
        SmartMarginAccountFactory: ADDRESSES.SmartMarginAccountFactory[networkId]
            ? {
                address: ADDRESSES.SmartMarginAccountFactory[networkId],
                abi: SmartMarginAccountFactoryAbi,
            }
            : undefined,
        // TODO: Replace these when we move away from wagmi hooks
        KwentaArrakisVault: ADDRESSES.KwentaArrakisVault[networkId]
            ? {
                address: ADDRESSES.KwentaArrakisVault[networkId],
                abi: KwentaArrakisVaultABI,
            }
            : undefined,
        StakingRewards: ADDRESSES.StakingRewards[networkId]
            ? {
                address: ADDRESSES.StakingRewards[networkId],
                abi: StakingRewardsABI,
            }
            : undefined,
        RewardEscrow: ADDRESSES.RewardEscrow[networkId]
            ? {
                address: ADDRESSES.RewardEscrow[networkId],
                abi: RewardEscrowABI,
            }
            : undefined,
        KwentaToken: ADDRESSES.KwentaToken[networkId]
            ? {
                address: ADDRESSES.KwentaToken[networkId],
                abi: ERC20ABI,
            }
            : undefined,
        SupplySchedule: ADDRESSES.SupplySchedule[networkId]
            ? {
                address: ADDRESSES.SupplySchedule[networkId],
                abi: SupplyScheduleABI,
            }
            : undefined,
        vKwentaToken: ADDRESSES.vKwentaToken[networkId]
            ? {
                address: ADDRESSES.vKwentaToken[networkId],
                abi: ERC20ABI,
            }
            : undefined,
        MarginEngine: ADDRESSES.MarginEngine[networkId]
            ? {
                address: ADDRESSES.MarginEngine[networkId],
                abi: MarginEngineABI,
            }
            : undefined,
        MultipleMerkleDistributorPerpsV2: ADDRESSES.TradingRewardsPerpsV2[networkId]
            ? {
                address: ADDRESSES.TradingRewardsPerpsV2[networkId],
                abi: MultipleMerkleDistributorPerpsV2ABI,
            }
            : undefined,
        MultipleMerkleDistributorStakingV2: ADDRESSES.TradingRewardsStakingV2[networkId]
            ? {
                address: ADDRESSES.TradingRewardsStakingV2[networkId],
                abi: MultipleMerkleDistributorPerpsV2ABI,
            }
            : undefined,
        MultipleMerkleDistributorOp: ADDRESSES.OpRewards[networkId]
            ? {
                address: ADDRESSES.OpRewards[networkId],
                abi: MultipleMerkleDistributorOpABI,
            }
            : undefined,
        MultipleMerkleDistributorSnxOp: ADDRESSES.SnxOpRewards[networkId]
            ? {
                address: ADDRESSES.SnxOpRewards[networkId],
                abi: MultipleMerkleDistributorOpABI,
            }
            : undefined,
        BatchClaimer: ADDRESSES.BatchClaimer[networkId]
            ? {
                address: ADDRESSES.BatchClaimer[networkId],
                abi: BatchClaimerABI,
            }
            : undefined,
        veKwentaToken: ADDRESSES.veKwentaToken[networkId]
            ? {
                address: ADDRESSES.veKwentaToken[networkId],
                abi: ERC20ABI,
            }
            : undefined,
        KwentaStakingRewards: ADDRESSES.KwentaStakingRewards[networkId]
            ? {
                address: ADDRESSES.KwentaStakingRewards[networkId],
                abi: KwentaStakingRewardsABI,
            }
            : undefined,
        vKwentaRedeemer: ADDRESSES.vKwentaRedeemer[networkId]
            ? {
                address: ADDRESSES.vKwentaRedeemer[networkId],
                abi: vKwentaRedeemerABI,
            }
            : undefined,
        veKwentaRedeemer: ADDRESSES.veKwentaRedeemer[networkId]
            ? {
                address: ADDRESSES.veKwentaRedeemer[networkId],
                abi: veKwentaRedeemerABI,
            }
            : undefined,
        KwentaStakingRewardsV2: ADDRESSES.KwentaStakingRewardsV2[networkId]
            ? {
                address: ADDRESSES.KwentaStakingRewardsV2[networkId],
                abi: KwentaStakingRewardsV2ABI,
            }
            : undefined,
        RewardEscrowV2: ADDRESSES.RewardEscrowV2[networkId]
            ? {
                address: ADDRESSES.RewardEscrowV2[networkId],
                abi: RewardEscrowV2ABI,
            }
            : undefined,
        PerpsV3MarketProxy: ADDRESSES.PerpsV3MarketProxy[networkId]
            ? {
                address: ADDRESSES.PerpsV3MarketProxy[networkId],
                abi: PerpsV3MarketProxyABI,
            }
            : undefined,
        PerpsV3AccountProxy: ADDRESSES.PerpsV3AccountProxy[networkId]
            ? {
                address: ADDRESSES.PerpsV3AccountProxy[networkId],
                abi: PerpsV3AccountProxyABI,
            }
            : undefined,
        SpotV3MarketProxy: ADDRESSES.SpotV3MarketProxy[networkId]
            ? {
                address: ADDRESSES.SpotV3MarketProxy[networkId],
                abi: SpotV3MarketProxy, // TODO: CHANGE ,
            }
            : undefined,
        EscrowMigrator: ADDRESSES.EscrowMigrator[networkId]
            ? {
                address: ADDRESSES.EscrowMigrator[networkId],
                abi: EscrowMigratorABI,
            }
            : undefined,
        BoostNft: ADDRESSES.BoostNft[networkId]
            ? {
                address: ADDRESSES.BoostNft[networkId],
                abi: BoostNftABI,
            }
            : undefined,
        DappMaintenance: ADDRESSES.DappMaintenance[networkId]
            ? {
                address: ADDRESSES.DappMaintenance[networkId],
                abi: DappMaintenanceABI,
            }
            : undefined,
        MultiCall3_1: ADDRESSES.Multicall3_1[networkId]
            ? {
                address: ADDRESSES.Multicall3_1[networkId],
                abi: MulticallABI,
            }
            : undefined,
        Permit2: ADDRESSES.Permit2[networkId]
            ? {
                address: ADDRESSES.Permit2[networkId],
                abi: Permit2ABI,
            }
            : undefined,
        SynthetixV3Proxy: ADDRESSES.SynthetixV3Proxy[networkId]
            ? {
                address: ADDRESSES.SynthetixV3Proxy[networkId],
                abi: SynthetixV3ProxyABI,
            }
            : undefined,
        GnosisSafeL2: ADDRESSES.GnosisSafeL2[networkId]
            ? {
                address: ADDRESSES.GnosisSafeL2[networkId],
                abi: GnosisSafeL2ProxyABI,
            }
            : undefined,
    };
};
